export enum GlucometerConsumables {
  'CBLS_G427B' = 'CBLS_G427B',
}
